import { ProgramV2Response } from "@getbread/api-client-program-v2";

export const isEcommerceProgram = ({ channel }: ProgramV2Response) => channel === "ECOMM";

export const isInstoreProgram = ({ channel }: ProgramV2Response) => channel === "INSTORE";

export const hasCheckoutSDKAccess = ({ displayInterestRateBPS }: ProgramV2Response) =>
	!!displayInterestRateBPS && displayInterestRateBPS > 0;

export const isVirtualCardProgram = ({ checkoutMode }: ProgramV2Response) =>
	checkoutMode === "VirtualCard";
